import './survey-details/survey-details.component';
import './survey-details/survey-details.scss';

import './survey-reviews-table/survey-reviews-table.component';
import './survey-reviews-table/survey-reviews-table.scss';

import './survey-reviews-table-row/survey-reviews-table-row.component';
import './survey-reviews-table-row/survey-reviews-table-row.scss';
